import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Trophy, Target, PartyPopper, User } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTheme } from '../contexts/ThemeContext';

const Navigation = ({ role }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { colors, designTemplate } = useTheme();

  const youthLinks = [
    { path: '/dashboard', icon: Home, label: 'Home' },
    { path: '/goals', icon: Target, label: 'Goals' },
    { path: '/wins', icon: PartyPopper, label: 'Wins' },
    { path: '/leaderboard', icon: Trophy, label: 'Ranks' },
    { path: '/profile', icon: User, label: 'Profile' },
  ];

  const links = role === 'youth' ? youthLinks : [];

  if (links.length === 0) return null;

  // Theme-aware styles
  const navStyle = {
    backgroundColor: colors?.surface ? `${colors.surface}F5` : 'rgba(255,255,255,0.95)',
  };

  const getActiveStyle = (isActive) => {
    if (isActive) {
      return {
        color: colors?.primary || '#1B2D4F',
        backgroundColor: colors?.primary ? `${colors.primary}15` : 'rgba(30, 107, 123, 0.1)',
      };
    }
    return {
      color: colors?.text_muted || '#5A7A8A',
    };
  };

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 backdrop-blur-lg border-t border-gray-200 px-2 py-2 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] z-[100]" 
      style={{ ...navStyle, position: 'fixed' }}
    >
      <div className="max-w-lg mx-auto flex justify-around items-center">
        {links.map((link) => {
          const Icon = link.icon;
          const isActive = location.pathname === link.path;
          return (
            <motion.button
              key={link.path}
              data-testid={`nav-${link.label.toLowerCase()}`}
              whileTap={{ scale: 0.9 }}
              onClick={() => navigate(link.path)}
              style={getActiveStyle(isActive)}
              className={`flex flex-col items-center gap-0.5 py-2 px-4 rounded-2xl transition-all hover:bg-gray-100`}
            >
              <Icon className={`w-6 h-6 ${isActive ? 'stroke-[2.5px]' : ''}`} />
              <span className={`text-[10px] font-medium ${isActive ? 'font-bold' : ''}`}>{link.label}</span>
            </motion.button>
          );
        })}
      </div>
      {/* Safe area for devices with home indicator */}
      <div className="h-safe-area-inset-bottom" />
    </nav>
  );
};

export default Navigation;
